module.exports = __webpack_public_path__ + "img/step_img_03.ffdc1a9e.webp";